import React from 'react';
import { Card } from './ui/card';
import { Play, Clock } from 'lucide-react';
import { featuredContent } from '../mock';

const FeaturedContent = () => {
  const handleCardClick = () => {
    // Scroll to hero CTA button
    document.getElementById('inicio')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  return (
    <section id="aovivo" className="py-16 md:py-24 bg-zinc-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4">
            Em <span className="text-red-600">Destaque</span>
          </h2>
          <p className="text-gray-400 text-lg md:text-xl">
            O melhor conteúdo selecionado para você
          </p>
        </div>

        {/* Content Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {featuredContent.map((content) => (
            <Card
              key={content.id}
              onClick={handleCardClick}
              className="group relative overflow-hidden bg-zinc-900 border-zinc-800 hover:border-red-600 transition-all duration-300 cursor-pointer"
            >
              {/* Thumbnail */}
              <div className="relative h-48 md:h-64 overflow-hidden">
                <img
                  src={content.image}
                  alt={content.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/40 group-hover:bg-black/60 transition-colors"></div>

                {/* Play Button Overlay */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="bg-red-600 w-16 h-16 rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-transform">
                    <Play className="w-8 h-8 text-white fill-white" />
                  </div>
                </div>

                {/* Live Badge */}
                {content.type === 'live' && (
                  <div className="absolute top-4 left-4 bg-red-600 text-white px-3 py-1 rounded-full text-sm font-bold flex items-center gap-1 animate-pulse">
                    <div className="w-2 h-2 bg-white rounded-full"></div>
                    AO VIVO
                  </div>
                )}

                {/* Duration Badge */}
                {content.type !== 'live' && (
                  <div className="absolute bottom-4 right-4 bg-black/80 text-white px-2 py-1 rounded text-xs flex items-center gap-1">
                    <Clock className="w-3 h-3" />
                    2h 15min
                  </div>
                )}
              </div>

              {/* Content Info */}
              <div className="p-4 md:p-6">
                <span className="text-red-500 text-sm font-semibold uppercase tracking-wide">
                  {content.category}
                </span>
                <h3 className="text-xl font-bold text-white mt-2 group-hover:text-red-500 transition-colors">
                  {content.title}
                </h3>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedContent;
